import React from "react";
import UnauthorizedErrorPage from "./UnauthorizedErrorPage";
const StreamPermissionErrorPage = ({ error, missingStreamIds = [] }) => {
  var _a, _b;
  const description = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "This resource includes streams you do not have permissions for."), /* @__PURE__ */ React.createElement("p", null, "Please contact your administrator and provide the error details which include a list of streams you need access to."));
  const streamIds = missingStreamIds.length > 0 ? missingStreamIds : (_b = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.body) == null ? void 0 : _b.streams;
  const errorDetails = (streamIds == null ? void 0 : streamIds.length) > 0 ? `You need permissions for streams with the id: ${streamIds.join(", ")}.` : void 0;
  return /* @__PURE__ */ React.createElement(
    UnauthorizedErrorPage,
    {
      error,
      description,
      title: "Missing Stream Permissions",
      errorDetails
    }
  );
};
export default StreamPermissionErrorPage;
